import "./style/RelifeCompany.css";
import { NavLink, Link } from "react-router-dom";
import Animation from "../animation/Animation";

const HOW_STEPS = [
  {
    num: "1",
    title: "Choose a theme",
    desc: "Pick what matter most to you right now.",
  },
  {
    num: "2",
    title: "Answer one honest question at a time",
    desc: "No essays. No journaling. Just one true response.",
  },
  {
    num: "3",
    title: "Receive a reflection that helps you see deeper",
    desc: "A calm voice mirrors what your answer may be revealing.",
  },
  {
    num: "4",
    title: "Move through five phases",
    desc: "Each phase gently moves you toward more clarity.",
  },
];
export default function RelifeCompany() {
  return (
    <>
      <section className="how-section" id="how">
        <div className="how-inner">
          <div className="how-header">
            <div>
              <div className="l-rule" />
              <span className="l-eyebrow">The process</span>
            </div>
            <h2 className="l-h2">A quiet way to understand yourself better.</h2>
          </div>

          <div className="how-steps how-steps--glass how-steps--four">
            {HOW_STEPS.map(({ num, title, desc }, i) => (
              <div key={num} className="how-step">
                <div className="how-step__num">{num}</div>
                <h3 className="how-step__title">{title}</h3>
                <p className="how-step__desc">{desc}</p>
              </div>
            ))}
          </div>

          <p className="how-footer-note">
            No pressure. No judgment. Just honest reflection.
          </p>
        </div>
      </section>
    </>
  );
}
